var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCarousel = function SvgArrowCarousel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.2 20 19.928 20L23 37.12 5.815 19.956l17.14-17.121L20.128 0z"
  })));
};
export default SvgArrowCarousel;